import { EnrollCardResponse } from 'types/api/enroll-card';
import { DpaTransactionOptions } from 'types/emvco';

export function isEnrollCardError(
  response: EnrollCardResponse,
  dpaTransactionOptions?: DpaTransactionOptions
): boolean {
  const {
    customOutputData: { dpaAccepted },
    maskedCard,
    srcCorrelationId
  } = response;

  if (dpaAccepted) {
    return false;
  }

  const isPendingAvs = maskedCard.digitalCardData.pendingEvents?.includes('PENDING_AVS') ?? false;

  // Unsupported billing address?
  if (srcCorrelationId && !isPendingAvs) {
    return true;
  }

  // If billing address not present (eg: V-SRCi flow), should launch VISA DCF.
  // Accepted billing countries will be present when onboarding a merchant
  if (
    !maskedCard.maskedBillingAddress?.countryCode ||
    // if no dpaAcceptedBillingCountries are set, all are accepted
    !dpaTransactionOptions?.dpaAcceptedBillingCountries?.length
  ) {
    return false;
  }

  const isAcceptedCountry = dpaTransactionOptions.dpaAcceptedBillingCountries.includes(
    maskedCard.maskedBillingAddress.countryCode
  );

  return !isAcceptedCountry;
}
